export default __webpack_public_path__ + "static/media/bank.ea6a87ad.png";